/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PauseResumeChargeTransactionTask
 */
export interface PauseResumeChargeTransactionTask {
    /**
     *
     * @type {number}
     * @memberof PauseResumeChargeTransactionTask
     */
    connectorIndex?: number;
    /**
     *
     * @type {number}
     * @memberof PauseResumeChargeTransactionTask
     */
    transactionId?: number;
    /**
     *
     * @type {boolean}
     * @memberof PauseResumeChargeTransactionTask
     */
    pause?: boolean;
}

/**
 * Check if a given object implements the PauseResumeChargeTransactionTask interface.
 */
export function instanceOfPauseResumeChargeTransactionTask(
    value: object,
): value is PauseResumeChargeTransactionTask {
    return true;
}

export function PauseResumeChargeTransactionTaskFromJSON(
    json: any,
): PauseResumeChargeTransactionTask {
    return PauseResumeChargeTransactionTaskFromJSONTyped(json, false);
}

export function PauseResumeChargeTransactionTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PauseResumeChargeTransactionTask {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        pause: json["pause"] == null ? undefined : json["pause"],
    };
}

export function PauseResumeChargeTransactionTaskToJSON(
    value?: PauseResumeChargeTransactionTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        transactionId: value["transactionId"],
        pause: value["pause"],
    };
}
